import { Injectable } from '@angular/core';
import { gql, Apollo } from 'apollo-angular';
import { Observable } from 'rxjs';
import { pluck } from 'rxjs/operators';
const getSecondHandSupplierQuery = gql`query
get_second_hand_supplies{
second_hand_supplies {
  id
  product_status
}
dental_suppliers{
  id
    business_name
  

 }
}`;
@Injectable({
  providedIn: 'root'
})
export class GetSecondHandSuppliersService {
/* ------------------------------- Constructor ------------------------------ */
  constructor(private apollo: Apollo) { }
/* -------------------------- Get Dental Suppliers -------------------------- */
getSecondHandSuppliers(): Observable<any>{
    return this.apollo.use('external').query({
      query: getSecondHandSupplierQuery
    }).pipe(pluck('data', 'dental_suppliers'));
  }
}
